/**
 * @Description:
 * @Author: huage
 * @Date: 2020/9/17
 */
export default {
    userList: {
        "userName": "User name",
        "password": "Password",
        "mobileNumber": "Mobile number",
        "mail": "Mail",
        "updateTime": "Update time",
        "state": "State",
        "edit": "Edit",
        "disable": "Disable",
        "enable": "Enable",
        "changePassword": "Change password",
        "delete": "Delete",
        "remarks": "Remarks",
        "newPassword": "New password",
        "userList": "User list",
        "confirmPassword": "Confirm password",
        "addUser": "Add user",
        "editUser": "Edit user",
        "back": "Back",
        "save": "Save",
        "applyName": "Apply name",
        "roleNumber": "Role number",
        "roleName": "Role name",

        "message1": "Password changed successfully",
        "message2": "Please enter a new password",
        "message3": "Please enter the confirmation password",
        "message4": "Combination of numbers and letters, no less than 6 digits",
        "message5": "Please enter your mobile phone number",
        "message6": "Please enter email address",
        "message7": "Save succeeded",
        "message8": "Please fill in the password",

        "text1": "User assigned role",
        "text2": "User account information",
        "text3": "Application and associated roles",

        "userDomain": "UserDomain"
      }
};


// WEBPACK FOOTER //
// ./src/config/langs/en_US/userList.js